export default __webpack_public_path__ + "static/media/img_major02_3.5a4d55dd.jpg";